<template>
	<div>
		<t-button size="sm" @click.native="onPopperCancel">{{ localeCancelText }}</t-button>
		<t-button type="primary" size="sm" @click.native="onPopperConfirm">{{ localeOkText }}</t-button>
	</div>
</template>
<script>
import TButton from '../button'
export default {
  props: {
    localeCancelText: {
      type: String
    },
    localeOkText: {
      type: String
    }
  },
  components: {
    TButton
  },
  data() {
    return {}
  },
  methods: {
    onPopperCancel() {
      this.$emit('on-popper-cancel')
    },
    onPopperConfirm() {
      this.$emit('on-popper-confirm')
    }
  }
}
</script>


// WEBPACK FOOTER //
// popper-button.vue?c8e1bd22